import { gql } from 'graphql-request'

export default gql`
  mutation createMedicalEquipment(
    $nome_cooperado: String
    $codigo_cooperado: String
    $crm: String
    $cep: String
    $endereco: String
    $numero: String
    $complemento: String
    $bairro: String
    $municipio: String
    $uf: String
    $nome_equipamento: String
    $marca: String
    $modelo: String
    $ano_fabricacao: String
    $numero_serie: String
    $exames: [MedicalEquipmentExameInput]
  ) {
    applications {
      medicalEquipment {
        createMedicalEquipment(
          nome_cooperado: $nome_cooperado
          codigo_cooperado: $codigo_cooperado
          crm: $crm
          cep: $cep
          endereco: $endereco
          numero: $numero
          complemento: $complemento
          bairro: $bairro
          municipio: $municipio
          uf: $uf
          nome_equipamento: $nome_equipamento
          marca: $marca
          modelo: $modelo
          ano_fabricacao: $ano_fabricacao
          numero_serie: $numero_serie
          exames: $exames
        ) {
          submission_id
          created_time
          message
        }
      }
    }
  }
`
